import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import emailjs from "@emailjs/browser";

import Navigation from "./components/Navigation/Navigation";
import { Page, Footer } from "./AppStyles";
import Home from "./pages/Home/Home";
import ERP from "./pages/ERP/ERP";
import ProjectManagement from "./pages/ProjectManagement/ProjectManagement";
import PropertyManagement from "./pages/PropertyManagement/PropertyManagement";
import AgriBusiness from "./pages/Agribusiness/Agribusiness";
import HortonHouse from "./pages/HortonHouse/HortonHouse";
import OurTeam from "./pages/OurTeam/OurTeam";
import ContactUs from "./pages/ContactUs/ContactUs";
import FooterComponent from "./components/Footer/Footer";
import BookASpace from "./pages/BookASpace/BookASpace";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";
import Immigration from "./pages/Immigration/Immigration";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import PreviewOverlay from "./components/PreviewOverlay";

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Inter', sans-serif;
  }

  body {
    color: #111;
    background: #fff;
    overflow-x: hidden;
  }
`;

// Initialize EmailJS using environment variable
const publicKey =
  process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

if (publicKey) {
  emailjs.init(publicKey);
} else {
  console.warn("EmailJS Public Key not found in environment variables.");
}

export default function App() {

  useEffect(() => {
    document.title = "August Twenty";
  }, []);

  return (
    <Router>
      <GlobalStyle />
      <ScrollToTop />
      <PreviewOverlay />
      <Routes>
        <Route
          path="/"
          element={
            <Page>
              <Navigation />
              <Home />
              <Footer>
                <FooterComponent />
              </Footer>
            </Page>
          }
        />

        <Route
          path="/erp"
          element={
            <Page>
              <Navigation />
              <ERP />
              <Footer>
                <FooterComponent />
              </Footer>
            </Page>
          }
        />

        <Route
          path="/project-management"
          element={
            <Page>
              <Navigation />
              <ProjectManagement />
              <Footer>
                <FooterComponent />
              </Footer>
            </Page>
          }
        />

        <Route
          path="/property-management"
          element={
            <Page>
              <Navigation />
              <PropertyManagement />
              <Footer>
                <FooterComponent />
              </Footer>
            </Page>
          }
        />

        <Route
          path="/agribusiness"
          element={
            <Page>
              <Navigation />
              <AgriBusiness />
              <Footer>
                <FooterComponent />
              </Footer>
            </Page>
          }
        />

        <Route
          path="/immigration"
          element={
            <Page>
              <Navigation />
              <Immigration />
              <Footer>
                <FooterComponent />
              </Footer>
            </Page>
          }
        />

        <Route
          path="/horton-house"
          element={
            <Page>
              <Navigation />
              <HortonHouse />
              <Footer>
                <FooterComponent />
              </Footer>
            </Page>
          }
        />

        <Route
          path="/our-team"
          element={
            <Page>
              <Navigation />
              <OurTeam />
              <Footer>
                <FooterComponent />
              </Footer>
            </Page>
          }
        />

        <Route
          path="/book-a-space"
          element={
            <Page>
              <Navigation />
              <BookASpace />
            </Page>
          }
        />

        <Route
          path="/terms-and-conditions"
          element={
            <Page>
              <Navigation />
              <TermsAndConditions />
            </Page>
          }
        />

        <Route
          path="/contact-us"
          element={
            <Page>
              <Navigation />
              <ContactUs />
              <Footer>
                <FooterComponent />
              </Footer>
            </Page>
          }
        />
      </Routes>
    </Router>
  );
}